import { instance } from './v2/instance';

export async function getPageByUrl(url: string) {
  try {
    const response = await instance.get(
      `${process.env.NEXT_PUBLIC_NBC_API_URL}/page-maker/url/${url}`,
    );
    return response.data;
  } catch (e) {
    console.error('getPageByUrl error:', e);
    return null;
  }
}

export async function postSurvey(data: any, collection: string) {
  try {
    const payload = {
      data,
      collection,
    };
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_NBC_API_URL}/page-maker/submit-form`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    );
    return res.json();
  } catch (e) {
    if (e instanceof Error) {
      throw e;
    }
  }
}
